import React, { useCallback, useEffect } from 'react'
import { Button } from '@/atoms/Button'
import { paths } from '@/constants/paths'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'

export const ErrorFallback: React.FC = () => {
  useEffect(() => {
    window?.scrollTo?.(0, 0)
  }, [])

  const { push } = useSafeRouter()

  const goHome = useCallback(() => {
    return push(paths.home)
  }, [push])

  return (
    <div className="w-full bg-core-gray-950">
      <div className="mx-auto py-48 text-center text-white md:max-w-[600px]">
        <h2 className="mb-4 text-3xl font-semibold">Sorry about that.</h2>
        <div className="leading-6">
          <div className="mb-4">
            Something seems to have gone terribly wrong!
            <div>
              Rest assured our best developers have been notified and will hopefully prevent this from happening in the
              future.
            </div>
          </div>
          <div className="mb-12">
            <div>Hopefully it won&apos;t happen again, but if it persists try going Home instead.</div>
          </div>
        </div>
        <div className="flex w-full justify-center">
          <Button variant="white" outline onClick={goHome}>
            Go Home
          </Button>
        </div>
      </div>
    </div>
  )
}
